<template>
<div class="closed-programs-page">
  <div class="closed-program-list-page" v-show="!isDetail">
    <p class="section-title">Closed Programs</p>
    <p class="section-sub-title">Here is a summary of your past programs: </p>
    <div v-for="(item, index) in viewLoans" :key="index">
      <div class="program-item">
        <div class="loan-item loan-name">{{ item.name }}</div>
        <div class="loan-item loan-date-pc date">Loan start date:<br>
          <div class="loan-date-svg">
            <div class="loan-svg"><svg-icon :name="'calendar'"></svg-icon>
            </div> {{item.loanStartDate}}
          </div>
        </div>
        <div class="loan-item loan-date-mobile date">
            <div class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></div>
            Loan start date: {{item.loanStartDate}}
        </div>
        <div class="loan-item loan-button">
          <maf-button :name="'View details'" :width="201" @actionFunc="viewDetails(item)"></maf-button>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in viewIFRPs" :key="index">
      <div class="program-item">
        <div class="loan-item loan-name">{{ item.name }}</div>
        <div class="loan-item loan-date-pc-ifrp date">Grant start date:<br>
          <div class="loan-date-svg">
            <div class="loan-svg"><svg-icon :name="'calendar'"></svg-icon>
            </div> {{item.grantStartDate}}
          </div>
        </div>
        <div class="loan-item loan-date-mobile date">
            <div class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></div>
            Grant start date: {{item.grantStartDate}}
        </div>
        <div class="loan-item loan-date-pc-ifrp end-data date">Grant end date:<br>
          <div class="loan-date-svg">
            <div class="loan-svg"><svg-icon :name="'calendar'"></svg-icon>
            </div> {{item.grantEndDate}}
          </div>
        </div>
        <div class="loan-item loan-date-mobile date">
            <div class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></div>
            Grant end date: {{item.grantEndDate}}
        </div>
      </div>
    </div>
  </div>
  <div class="closed-program-detail-page" v-show="isDetail">
    <div class="back-arrow" @click="back" v-show="isDetail" tabindex="0" @keydown.enter.space.self="back" style="outline: none; cursor: pointer;">
      <svg-icon :name="'back-arrow'" style="pointer-events: none;"></svg-icon>
      <span style="pointer-events: none;">Back</span>
    </div>
    <p class="section-title">{{ selectedLoan.name }}</p>
    <p class="section-sub-title">Here is your current loan information </p>
    <div>
      <div class="current-loan-info-pc">
        <div class="loan-infos">
          <div class="loan-info border">
            <div class="loan-info-label">Status: </div>
            <div class="loan-info-value">
              <svg-icon :name="'lock'"></svg-icon>
              <span>{{ selectedLoan.loanStatus }}</span>
            </div>
            <div class="loan-info-label">Next due date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.nextDueDate }}</span>
            </div>
          </div>
          <div class="loan-info border">
            <div class="loan-info-label">Next payment due: </div>
            <div class="loan-info-value">
              <svg-icon :name="'currency-dollar'"></svg-icon>
              <span>${{ selectedLoan.nextPaymentAmount }}</span>
            </div>
            <div class="loan-info-label">Distribution date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.distributionDate }}</span>
            </div>
          </div>
          <div class="loan-info border">
            <div class="loan-info-label">Loan amount: </div>
            <div class="loan-info-value">
              <svg-icon :name="'currency-dollar'"></svg-icon>
              <span>${{ selectedLoan.loanAmount }}</span>
            </div>
            <div class="loan-info-label">Loan start date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.loanStartDate }}</span>
            </div>
          </div>
          <div class="loan-info">
            <div class="loan-info-label">Loan balance: </div>
            <div class="loan-info-value">
              <svg-icon :name="'accounting-document'"></svg-icon>
              <span>${{ selectedLoan.loanBalance }}</span>
            </div>
            <div class="loan-info-label">Loan end date: </div>
            <div class="loan-info-value">
              <svg-icon :name="'calendar'"></svg-icon>
              <span>{{ selectedLoan.loanEndDate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="current-loan-info-mobile">
        <div class="loan-infos">
          <div class="loan-info">
              <span class="loan-svg">
                <svg-icon :name="'lock'"></svg-icon>
                </span>
              <span>Status: &nbsp;</span>
              <span>Closed</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg">
              <svg-icon :name="'currency-dollar'"></svg-icon>
            </span>
            <span>Next payment due: &nbsp;</span>
            <span>${{ selectedLoan.nextPaymentAmount }}</span>
          </div>
          <div class="loan-info">
              <span class="loan-svg"><svg-icon :name="'currency-dollar'"></svg-icon></span>
              <span>Loan amount: &nbsp;</span>
              <span>${{ selectedLoan.loanAmount }}</span>
          </div>
          <div class="loan-info">
              <span class="loan-svg"><svg-icon :name="'accounting-document'"></svg-icon></span>
              <span>Loan balance: &nbsp;</span>
              <span>${{ selectedLoan.loanBalance }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Next due date: &nbsp;</span>
            <span>{{ selectedLoan.nextDueDate }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Distribution date: &nbsp;</span>
            <span>{{ selectedLoan.distributionDate }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Loan start date: &nbsp;</span>
            <span>{{ selectedLoan.loanStartDate }}</span>
          </div>
          <div class="loan-info">
            <span class="loan-svg"><svg-icon :name="'calendar'"></svg-icon></span>
            <span>Loan end date: &nbsp;</span>
            <span>{{ selectedLoan.loanEndDate }}</span>
          </div>
        </div>
      </div>
    </div>
    <p class="section-sub-title">Here is your payment activity </p>
    <div class="payment-activity">
      <div class="payment-activity-pc">
        <div class="payment-transaction-items">
          <div class="table-title">Date</div>
          <div class="table-title">Amount</div>
          <div class="table-title">Principal</div>
          <div class="table-title">Fees</div>
          <div class="table-title">Interest</div>
          <div class="table-title">Status</div>
        </div>
        <div v-for="(payment, index) in selectedLoan.loanPaymentTransactions" :key="index">
          <div class="payment-transaction-items">
            <div>{{  payment.transactionDate }}</div>
            <div>${{  payment.transactionAmount }}</div>
            <div>${{  payment.principal }}</div>
            <div>${{  payment.fees }}</div>
            <div>${{  payment.interest }}</div>
            <div>{{  payment.computedPaymentStatus }}</div>
          </div>
        </div>
        <div class="payment-transaction-items">
          <div>Total</div>
          <div>${{ selectedLoan.totalAmount }}</div>
          <div>${{ selectedLoan.totalPrincipal }}</div>
          <div>${{ selectedLoan.totalFees }}</div>
          <div>${{ selectedLoan.totalInterest }}</div>
          <div></div>
        </div>
      </div>
      <div class="payment-activity-mobile">
        <div v-for="(payment, index) in selectedLoan.loanPaymentTransactions" :key="index">
          <div class="activity-card">
            <div class="unfold-infos" v-show="payment.isFold">
              <div class="unfold-info">
                <span>Date: {{ payment.transactionDate }}</span>
                <span>Amount: ${{ payment.transactionAmount }}</span>
                <span>Status: {{  payment.computedPaymentStatus }}</span>
              </div>
              <div class="unfold-arrow">
                <span @click="unfold(index)"><svg-icon :name="'dropdown'" :width="12" :height="12"></svg-icon></span>
              </div>
            </div>
            <div class="fold-infos" v-show="!payment.isFold">
              <div class="fold-info">
                <span>Date: {{ payment.transactionDate }}</span>
                <span>Amount: ${{ payment.transactionAmount }}</span>
                <span>Principal: ${{ payment.principal }}</span>
                <span>Fees: ${{ payment.fees }}</span>
                <span>Interest: ${{ payment.interest }}</span>
                <span>Status: {{  payment.computedPaymentStatus }}</span>
              </div>
              <div class="fold-arrow">
                <span @click="fold(index)"><svg-icon class="drop-up" :name="'dropdown'" :width="12" :height="12"></svg-icon></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="section-sub-title">Here are your loan statements </p>
    <div class="loan-statement-pc">
      <div class="statement-lables">
        <div class="statement-lable name">Loan Statement</div>
        <div class="statement-lable button">Download link</div>
      </div>
      <div v-for="file in selectedLoan.paymentFiles" :key="file.id">
        <div class="statement-values">
          <div class="statement-doc notranslate">{{ file.name }}</div>
          <div class="statement-button button">
            <div class="download-button"><maf-button :name="'Download'" :width="135" @actionFunc="download(file.id)"></maf-button></div>
          </div>
        </div>
      </div>
    </div>
    <div class="loan-statement-mobile">
      <div v-for="file in selectedLoan.paymentFiles" :key="file.id">
        <div class="statement-file">
          <div class="file-name notranslate">{{ file.name }}</div>
          <div class="download-button"><maf-button :name="'Download'" :width="135" @actionFunc="download"></maf-button></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { getViewLoansRemoting } from '../../api'

export default {
  name: 'ClosedPrograms',
  data () {
    return {
      selectedLoan: {},
      isDetail: false,
      isFold: true,
    };
  },
  computed: {
    ...mapState({
      viewLoans: state => state.dashboardHomeData.program.closedProgram.viewLoans,
      viewIFRPs: state => state.dashboardHomeData.program.closedProgram.viewIFRPs,
      userInfo: state => state.userInfo,
    }),
  },
  mounted() {
    this.setRecordById();
  },
  methods: {
    setRecordById() {
      const id = this.$route.params.recordId;
      if (id) {
        let viewRecord = this.viewLoans.filter((item) => (item.id).substring(0, 15) === id.substring(0, 15));
        if (viewRecord) {
          this.viewDetails(viewRecord[0]);
        } else {
          console.error('No matching record found by Id');
        }
      }
    },
    viewDetails(viewLoan) {
      this.isDetail = true;
      this.selectedLoan = viewLoan;
      console.log(this.selectedLoan.name)
      this.$router.push(`/closedPrograms/${this.selectedLoan.id}`);

      this.$nextTick(() => {
        document.getElementById('mainPage').scrollIntoView();
      })
    },

    back() {
      this.$router.push('/closedPrograms'); // Remove Id from URL
      this.isDetail = false;
    },

    async download(fileId) {
      await getViewLoansRemoting(this.userInfo.userId);
      window.open('/lendingcircles/servlet/servlet.FileDownload?file=' + fileId, '_blank');
    },

    unfold(index) {
      this.selectedLoan.loanPaymentTransactions[index].isFold = false;
    },

    fold(index) {
      this.selectedLoan.loanPaymentTransactions[index].isFold = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /*pc*/
  @import './../../sass/main.scss';
  .closed-programs-page {
    padding: 50px;
    font-size: $font-size-large;
    width: 100%;
    height: 100%;

    /*mobile*/
    @media only screen and (max-width: $max-width-phone) {
      padding: 20px;
      font-size: $font-size-base;
      width: unset;
      height: 100%;
    }

    .section-title {
      margin-bottom: 20px;
      font-size: 25px;
      color: #834BC4;

      @media only screen and (max-width: $max-width-phone) {
        margin-bottom: 10px;
        font-size: 20px;
      }
    }

    .section-sub-title {
      margin-bottom: 20px;
      color: $font-color-sub-title;
      font-size: $font-size-larger;

      @media only screen and (max-width: $max-width-phone) {
        margin-bottom: 10px;
        font-size: $font-size-large;
      }
    }

    .back-arrow {
      margin-bottom: 20px;
      @include space-between-style;
      width: 70px;
      color: $font-color-sub-title;
      cursor: pointer;
    }

  .program-item {
    @include inline-flex-row;
    margin-bottom: 10px;
    width: 100%;
    border-radius: 7px;
    color: $font-color-sub-title;
    background-color:  #F4F4F4;

    @media only screen and (max-width: $max-width-phone) {
      @include inline-flex-col;
      margin-bottom: 20px;
    }

    .loan-item {
      padding: 15px;
      @include center-style;
      justify-content: flex-start;
      line-height: 1.3;
      height: 72px;

      @media only screen and (max-width: $max-width-phone) {
        @include inline-flex-row;
        justify-content: flex-start;
        align-items: center;
        width: unset;
      }
    }

    .loan-name {
      flex: 1;
      justify-content: flex-start;
      height: auto;

      @media only screen and (max-width: $max-width-phone) {
        width: unset;
        padding: 15px;
      }
    }

    .date {
      .loan-date-svg {
        display: flex;
        align-items: center;

        .loan-svg {
          padding-right: 10px;
        }
      }
    }

    .loan-date-pc {
      flex-direction: column;
      width: 205px;
      padding-bottom: 5px;
      border-left: 2px solid $bg-color-white;
      border-right: 2px solid $bg-color-white;
      height: auto;
      br {
        display: none;
      }
    }

    .loan-date-pc-ifrp {
      flex-direction: column;
      width: 205px;
      padding-bottom: 5px;
      border-left: 2px solid $bg-color-white;
      border-right: 2px solid $bg-color-white;
      height: auto;
      br {
        display: none;
      }
    }

    .end-data {
      width: 225px;
    }

    .loan-date-mobile {
      display: none;
    }

    .grant-date-pc {
      width: 50%;
      border-left: 2px solid $bg-color-white;
      flex-direction: column;
      align-items: flex-start;
    }

    .grant-date-mobile {
      display: none;
    }

    .grant-name-pc {
      width: 50%;
      align-items: center;
    }

    .grant-name-mobile {
      display: none;
    }

    @media only screen and (max-width: $max-width-phone) {
      .date {
        .loan-svg {
          margin-right: 5px;
        }
      }

      .loan-date-pc {
        display: none;
      }

      .loan-date-pc-ifrp {
        display: none;
      }

      .loan-date-mobile {
        display: flex;
        padding: 15px;
        width: unset;
        border-top: 2px solid white;
        border-bottom: 2px solid white;
      }

      .grant-date-pc {
        display: none;
      }

      .grant-date-mobile {
        display: flex;
        padding: 15px;
        width: unset;
        border-top: 2px solid white;
        border-bottom: 2px solid white;
      }

      .grant-name-pc {
        display: none;
      }

      .grant-name-mobile {
        display: inherit;
        width: 100%;
      }
    }

    .loan-button {
      justify-content: center;
      width: 225px;
      height: auto;

      @media screen and (max-width: $max-width-phone) {
        width: unset;
        padding: 15px;

        .maf-btn {
          width: 100% !important;
        }
      }
    }
  }

  .current-loan-info-mobile {
    display: none;
  }

  .current-loan-info-pc {
    margin-bottom: 40px;

    .loan-infos {
      background-color:  #F4F4F4;
      color: $font-color-sub-title;
      border-radius: 7px;
      @include inline-flex-row;
      justify-content: space-between;
      width: 100%;
      min-height: 154px;

      .loan-info {
        padding: 15px;
        flex: 1;
        line-height: 1.3;

        .loan-info-label {
          padding-top: 10px
        }

        .loan-info-value {
          display: flex;
          align-items: center;

          span {
            margin-left: 10px;
          }
        }
      }
    }

    .border {
      border-right: 2px solid white;
    }
  }

  @media only screen and (max-width: $max-width-phone) {
    .current-loan-info-pc {
      display: none;
    }

    .current-loan-info-mobile {
      @include inline-flex-col;
      margin-bottom: 20px;
      width: 100%;

      .loan-infos {
        background-color:  #F4F4F4;
        color: $font-color-sub-title;
        border-radius: 7px;
        @include inline-flex-col;
        justify-content: space-between;
        font-size: 15px;

        .loan-info {
          padding: 15px;
          @include inline-flex-row;
          border: 1px solid white;

          .loan-svg {
            padding-right: 10px;
          }
        }
      }
    }
  }

  .payment-activity-mobile {
    display: none;
  }

  .payment-activity-pc {
    margin-bottom: 40px;
    background-color:  #F4F4F4;
    width: 100%;
    border-radius: 7px;

    .payment-transaction-items {
      color: #393C40;
      font-size: $font-size-base;
      @include flex-row;
      justify-content: space-between;
      border-top: 2px solid white;
      font-family: sans-serif;

      div {
        padding: 15px;
        flex: 1;
      }

      .table-title {
        color: $font-color-sub-title;
        font-family: ncaDashboardFont, Arial, sans-serif;
      }
    }
  }

  @media only screen and (max-width: $max-width-phone) {
    .payment-activity-pc {
      display: none;
    }

    .payment-activity-mobile {
      @include inline-flex-col;
      margin-bottom: 20px;
      width: 100%;

      .activity-card {
        @include inline-flex-col;
        margin-bottom: 10px;
        color: $font-color-sub-title;
        justify-content: space-between;
        font-size: 15px;
        width: 100%;
        border-radius: 7px;
        background-color:  #F4F4F4;

        .unfold-infos {
          @include inline-flex-row;
          padding: 10px;
          justify-content: space-around;

          .unfold-info {
            @include inline-flex-col;
            flex: 1;

            span {
              padding-bottom: 5px;
            }
          }

          .unfold-arrow {
            padding-top: 12px;
          }
        }

        .fold-infos {
          @include inline-flex-row;
          justify-content: space-around;
          padding: 10px;

          .fold-info {
            @include inline-flex-col;
            flex: 1;

            span {
              padding-bottom: 5px;
            }
          }

          .fold-arrow {
            padding-top: 12px;

            .drop-up {
              transform: rotateX(180deg);
            }
          }
        }
      }
    }
  }

  .loan-statement-mobile {
    display: none;
  }

  .loan-statement-pc {
    margin-bottom: 20px;
    background-color:  #F4F4F4;
    border-radius: 7px;
    width: 100%;

    .statement-lables {
      @include flex-row;
      justify-content: space-between;
      align-items: flex-start;
      height: 50px;
      color: $font-color-sub-title;

      .statement-lable {
        padding: 15px;
      }

      .button {
        width: 200px;
      }
    }

    .statement-values {
      @include flex-row;
      justify-content: space-between;
      justify-content: center;
      border-top: 2px solid white;
      font-size: $font-size-base;
      color: #393C40;

      .statement-doc {
        flex: 1;
        padding: 15px;
        font-family: sans-serif;
      }

      .statement-button {
        margin-top: 5px;
        width: 200px;
      }
    }
  }

  @media only screen and (max-width: $max-width-phone) {
    .loan-statement-pc {
      display: none;
    }

    .loan-statement-mobile {
      @include inline-flex-col;
      width: 100%;

      .statement-file {
        @include inline-flex-col;
        padding: 10px;
        margin-bottom: 10px;
        width: 100%;
        border-radius: 7px;
        background-color: #F4F4F4;

        .file-name {
          padding-bottom: 10px;
          font-size: 15px;
          color: $font-color-sub-title;
        }

        .download-button {
          padding-bottom: 10px;
          width: 100%;

          @media only screen and (max-width: $max-width-phone) {
            .maf-btn {
              width: 100% !important;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/closed-programs/ClosedPrograms.vue